import React from "react";

const LoginRight: React.FC = () => {
    const handleSubmit = (event: any) => {
        event.preventDefault();
        console.log('Submitted');
        
        alert("Form Submitted!");
    }
    return (
        <div className="flex flex-col h-full lg:w-[55%] w-full justify-between bg-white py-12 text-lg">
            <div className="mb-6">
                <div className="mb-6 leading-6 w-[85%] mx-auto">
                    <span className="text-3xl font-extrabold">Log in to <span className="text-[#DFA321]">Murwiza</span> </span> <br />
                    <span className="text-[#D9D9D9]">Welcome Back!</span>
                </div>
                <div className="flex flex-col leading-9 w-full items-center">
                    <input className="outline-none p-3 bg-[#F7F7F7] mb-6 w-[85%] rounded-md pl-4" type="email" placeholder="Email address" required />
                    <input className="outline-none p-3 bg-[#F7F7F7] mb-6 w-[85%] rounded-md pl-4" type="password" placeholder="Password" required />
                    <div className="mb-6 leading-6 w-[85%] mx-auto">
                        <span className="text-[#5182FF]"><a href="#resetPassword">Forgot Password?</a> </span>
                    </div>
                    <button className="w-[85%] bg-[#5182FF] p-2 mb-5 pl-4 text-white" onClick={handleSubmit}>Login</button>
                </div>
            </div>
            <div className="mb-6 leading-6 w-[85%] text-center">
                <span className="mr-4">Don’t have an account? </span>
                <span className="text-[#5182FF]"><a href="#signup">Sign up</a> </span>
            </div>
        </div>
    )
}
export default LoginRight;